import React from 'react';
import { Editor } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';
import { KatIcon } from '@amzn/katal-react';
import { MarkTypes } from 'src/types/CustomSlateTypes';
import ToolbarButton from './ToolbarButton';

export type MarkButtonProps = {
  format: MarkTypes,
  icon: KatIcon.Name
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const MarkButton = ({ format, icon, ...rest }: MarkButtonProps) => {
  const editor = useSlate();

  let isActive = false;
  if (editor.selection && ReactEditor.hasRange(editor, editor.selection)) {
    const marks = Editor.marks(editor);
    isActive = !!(marks && marks[format]);
  }

  return (
    <ToolbarButton
      isActive={isActive}
      onMouseDown={(event) => {
        event.preventDefault();
        if (isActive) {
          Editor.removeMark(editor, format);
        } else {
          Editor.addMark(editor, format, true);
        }
      }}
      {...rest}
    >
      <KatIcon name={icon} size="small" />
    </ToolbarButton>
  );
};

export default MarkButton;
